import React, { Component } from 'react';
import { connect } from 'react-redux';
import HealthView from './Health.view';

export class HealthContainer extends Component {

  constructor(props) {
    super(props);
    this.clearCache = this.clearCache.bind(this);
    this.restart = this.restart.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_HEALTH_DATA'
    });
  }

  clearCache(){
    const { dispatch } = this.props;
    dispatch({
      type: 'CLEAR_CACHE',
      payload: {}
    });
  }

  restart(){
    const { dispatch } = this.props;
    if(confirm('WARNING: do not do this more than once per minute.')){
      dispatch({
        type: 'SYNC_RESTART',
        payload: {}
      });
    }
  }

  render() {
    return (<HealthView
      {...this.state}
      {...this.props}
      clearCache={this.clearCache}
      restart={this.restart}
    />);
  }

}

function mapStateToProps(state) {
  const { health } = state;
  return {
    ...health,
  };
}

export default connect(mapStateToProps)(HealthContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Health/Health.container.js